import React, { FC, useCallback } from "react";
import { Link } from "../../ActionsSelectors/Link";
import { Typography } from "../../Fundamentals/Typography";
import { Divider } from "../../DataDisplay/Divider";
import { LinksList } from "./MyAccountDropdownList.interface";
import { mockedMyAccountDropdownLinksList } from "../../../mock/myAccountDropdownLinksList";
import { SvgIcon } from "../../Icons";

export interface IMyAccountDropdownListProps {
  classes?: {
    root?: string;
  };
  linksList?: LinksList;
  onItemClick?(): void;
  accountLink?: string;
  logouLink?: string;
  myAccountText?: string;
  logOutText?: string;
}

const MyAccountDropdownList: FC<IMyAccountDropdownListProps> = ({
  classes,
  linksList = mockedMyAccountDropdownLinksList,
  onItemClick,
  accountLink = "/mock-url/my-account",
  logouLink = "/logout",
  myAccountText = "My Account",
  logOutText = "Log out",
}) => {
  const handleItemClick = useCallback(() => {
    onItemClick && onItemClick();
  }, [onItemClick]);
  return (
    <ul
      className={`${classes?.root || ""} entry-point position-relative d-block`}
      style={{ visibility: "inherit" }}
    >
      <li className="d-flex py-6">
        <Link
          classes={{ root: "text-decoration-none" }}
          href={accountLink}
          onClick={handleItemClick}
        >
          <Typography
            data-testid="DropdownList__item"
            variant="h-menu-small-bold"
            classes={{ root: "text-color-white" }}
          >
            {myAccountText}
          </Typography>
        </Link>
      </li>
      <Divider color="grey" classes={{ root: "mt-0 mb-5" }} />
      {linksList.map((item) => (
        <li className="d-flex py-5" key={item.title}>
          <Link
            classes={{ root: "text-decoration-none" }}
            href={item.link.href}
            onClick={handleItemClick}
          >
            <Typography
              data-testid="DropdownList__item"
              variant="text-menu"
              classes={{ root: "text-color-white" }}
            >
              {item.title}
            </Typography>
          </Link>
        </li>
      ))}
      <li className="d-flex pt-7 pb-5">
        <Link
          classes={{ root: "text-decoration-none" }}
          href={logouLink}
          onClick={handleItemClick}
        >
          <Typography
            data-testid="DropdownList__item"
            variant="text-menu"
            classes={{ root: "d-flex align-items-center  text-color-white" }}
          >
            <SvgIcon
              classes={{ root: "icon-container me-3" }}
              type="svg-icon"
              icon="LogoutIcon"
            />
            <span data-testid="DropdownList__logout">{logOutText}</span>
          </Typography>
        </Link>
      </li>
    </ul>
  );
};

export default MyAccountDropdownList;
